module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAhCAYAAACvBDmYAAAAAXNSR0IArs4c6QAAAMxJREFUWAljdJ7z6z/DUABDwaEgNzINhcAEuXHIOJQFPUTd53zHm2ZZWJhNtiawnUXXR2v+kAnRUYdSOykMmRDFyEzEhgShTEesObjU7UzhZESWw3AoIyPjX2QF6Ow//xjwlgro6qnFx3DojmQODDFqWUaJOUM3jRJKe6MFPoF0MWSiftShBGKSZOkhE6IYZeZogU9yZKNqGLpRP1rgo8YkybyhG/XEehW9vUisPnLVDZkQHTIOHS3wyU2LuPQNmagfMg5lHArDjqDkAABGay88otBulQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/mixers/QuickSelection-05.png
// module id = 1075
// module chunks = 2